import React, { Component } from "react";
import { LargeItem } from "../components/items";
import Avatar from "../assets/images/avatar.jpg";
import Lieu from "../model/lieux";

class Favorite extends Component {
    render() {
        return (
            <div className="album py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h4>Mes favoris</h4>
                        </div>
                        <LargeItem image={Avatar} lieu={new Lieu(Avatar, "Article", "42", "5 rue des aigles", "une petite description"
                            , "5 h 10", "4 h 30", null, null, null,
                            "HOTEL", "069030642")} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Favorite;